import React from 'react';
import { PageHeader, Card, RoleBadge } from '../../components/ui';
import { useLms } from '../../context/LmsContext';
import { fullName } from '../../utils/lmsSelectors';

export default function Profile() {
  const { currentUser } = useLms();
  return (
    <>
      <PageHeader title="Profile" eyebrow="My account" description="Account information is linked to your Supabase Auth login and LMS role profile." />
      <div className="grid two">
        <Card>
          <h2>{fullName(currentUser)}</h2>
          <p className="muted">{currentUser.title}</p>
          <RoleBadge role={currentUser.role} />
          <dl className="details-list">
            <div><dt>Email</dt><dd>{currentUser.email}</dd></div>
            <div><dt>Team</dt><dd>{currentUser.team}</dd></div>
            <div><dt>Status</dt><dd>{currentUser.status}</dd></div>
            <div><dt>Timezone</dt><dd>{currentUser.timezone}</dd></div>
          </dl>
        </Card>
        <Card>
          <h2>Notification preferences</h2>
          <p className="muted">Future backend version can store email, in-app, due soon, overdue, and certificate expiration preferences.</p>
          <label className="check-row"><input type="checkbox" defaultChecked /> Course assignment emails</label>
          <label className="check-row"><input type="checkbox" defaultChecked /> Due soon reminders</label>
          <label className="check-row"><input type="checkbox" defaultChecked /> Certificate notices</label>
        </Card>
      </div>
    </>
  );
}
